<template>
    <button :disabled="disabled" :class="[
      'button-component',

      ...buttonClasses
  ]">
        <slot name="prepend"/>
        <slot/>
        <slot name="append"/>
    </button>
</template>

<script>
export default {
    name: "ButtonComponent",
    props: {
        kind: {
            type: String,
            required: false,
            default: 'primary',
            validator: (kind) => {
                return [
                    'primary',
                    'secondary',
                    'tertiary',
                    'danger',
                    'link'
                ].indexOf(kind) > -1
            }
        },
        disabled: {
          type: Boolean,
          default: false
        }
    },
    computed: {
        buttonClasses() {
            let list = []
            if (this.kind) {
                list.push(`button-component_${this.kind}`)
            }
            return list
        }
    }
}
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.button-component {
    padding: 14px 32px;
    border-radius: 32px;
    transition: all .2s ease;
    cursor: pointer;
    border: 1px solid transparent;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    font-weight: 600;

    &_primary {
        color: $white;
        background-color: $blue-light;
        border-color: $blue-light;
        &:hover{
            color: $white;
            background-color: $blue;
            border-color: $blue;
        }
    }
    &_secondary {
        color: $blue-light;
        background-color: transparent;
        border-color: $blue-light;
        &:hover{
            color: $blue;
            background-color: transparent;
            border-color: $blue;
        }
    }
    &_tetriary {
        color: $blue-light;
        background-color: transparent;
        border-color: transparent;
        &:hover{
            color: $blue;
            background-color: transparent;
            border-color: transparent;
        }
    }

    &.btn-sm {
        padding: 8px 18px;
    }

    &:disabled{
        background-color: $gray-light1;
        color: $gray-dark;
        border-color: $gray-light1;
        &:hover{
            background-color: $gray-light1 !important;
            color: $gray-dark !important;
            border-color: $gray-light1 !important;
        }
    }
}
</style>